import Axios from "../../utils/union-axios";

/**
 * 老带新活动邀请人页内容
 */
export function QueryInviterPage(data) {
  return Axios.post(`/web-h5/charge/interactActivity/queryInviterPage`, data);
}

/**
 * 老带新活动邀请人列表tab内容
 */
export function QueryInviteList(data) {
  return Axios.post(`/web-h5/charge/interactActivity/queryInviteList`, data);
}

/**
 * 老带新获取近期周期列表
 */
export function QueryRecentCycleList(data) {
  return Axios.post(`/web-h5/charge/interactActivity/recentCycleList`, data);
}

/**
 * 老带新排行榜信息查询
 */
export function QueryRankingPage(data) {
  return Axios.post(`/web-h5/charge/interactActivity/queryRankingPage`, data);
}

/**
 * 老带新我的奖励列表查询
 */
export function MyPrizePage(data) {
  return Axios.post(`/web-h5/charge/interactActivity/myPrizePage`, data);
}

/**
 * 获取用户信息
 */
export function getCurrentUserInfo() {
  return Axios.get(`/web-h5/charge/member/getCurrentUserInfo`)
}
/**
 * 获取微信小程序码
 */
export function getWXMiniQRCode(data) {
  return Axios.post(`/web-h5/charge/interactActivity/shareWXMiniQRCode`, data);
}
